<template>
    <div>
        <ValidationObserver ref="mainformvalidation">
            <form ref="mainform" :action="'/'+__('redeem.current_langcode')+'/redeem/checkout'" method="post">
                <input type="hidden" name="_token" :value="csrf">
                <input type="hidden" name="order_id" :value="order_id">
                <input type="hidden" name="no_address_change" :value="(allow_address_change ? 0 : 1)">

                <ValidationProvider v-if="form.delivery_type !== 'online' && select_delivery_dates.length > 1" vid="delivery_date" :name="__('redeem.delivery_date')" rules="required" v-slot="{ errors }">
                    <div class="form-group">
                        <label class="text-uppercase" for="delivery_date">{{ __('redeem.delivery_date') }}</label>
                        <select
                            v-if="allow_delivery_change"
                            id="delivery_date"
                            class="form-control"
                            name="delivery_date" v-model="form.delivery_date"
                            :class="{ 'is-invalid':errors[0] }"
                        >
                            <option v-for="(date, d_index) in select_delivery_dates" :key="d_index" :value="date.id">
                                {{ date.text }}
                            </option>
                        </select>
                        <input v-else type="text" name="delivery_date" class="form-control" :value="form.delivery_date" readonly>
                        <span class="invalid-feedback">{{ errors[0] }}</span>
                    </div>
                </ValidationProvider>
                <input v-else type="hidden" name="delivery_date" v-model="form.delivery_date">

                <ValidationProvider vid="delivery_type" :name="__('redeem.delivery_type')" rules="required" v-slot="{ errors }">
                    <div class="form-group" v-if="((allowed_deliv_types & 1) === 1) || ((allowed_deliv_types & 2) === 2)">
                        <label class="text-uppercase">{{ __('redeem.delivery_type') }}</label>
                        <div>
                            <div v-if="(allowed_deliv_types & 1) === 1" class="form-check form-check-inline">
                                <input class="form-check-input" type="radio" name="delivery_type" id="delivery_type_c"
                                       value="DPD_F" v-model="form.delivery_type"
                                       v-bind:class="{ 'is-invalid':errors[0] }" :readonly="!allow_address_change">
                                <label class="form-check-label" for="delivery_type_c">{{ __('redeem.to_company_address') }}</label>
                            </div>
                            <div v-if="card_type !== 'ccard_fi' && (allowed_deliv_types & 1) == 1" class="form-check form-check-inline">
                                <input class="form-check-input" type="radio" name="delivery_type" id="delivery_type_h"
                                       value="DPD_H" v-model="form.delivery_type"
                                       v-bind:class="{ 'is-invalid':errors[0] }" :readonly="!allow_address_change">
                                <label class="form-check-label" for="delivery_type_h">{{ __('redeem.to_home_address') }}</label>
                            </div>
                            <div v-if="(allowed_deliv_types & 2) === 2" class="form-check form-check-inline">
                                <input class="form-check-input" type="radio" name="delivery_type" id="delivery_type_o"
                                       value="postoffice" v-model="form.delivery_type"
                                       v-bind:class="{ 'is-invalid':errors[0] }" :readonly="!allow_address_change">
                                <label class="form-check-label" for="delivery_type_o">{{ __('redeem.to_postoffice') }}</label>
                            </div>
                        </div>
                        <span class="invalid-feedback" v-bind:class="{ 'd-block':errors[0] }">{{ errors[0] }}</span>
                    </div>
                    <div v-else-if="(allowed_deliv_types & 4) === 4">
                        <input type="hidden" name="delivery_type" v-model="form.delivery_type">
                        <span class="invalid-feedback" v-bind:class="{ 'd-block':errors[0] }">{{ errors[0] }}</span>
                    </div>
                    <div v-else-if="(allowed_deliv_types & 8) === 8">
                        <input type="hidden" name="delivery_type" v-model="form.delivery_type">
                        <span class="invalid-feedback" v-bind:class="{ 'd-block':errors[0] }">{{ errors[0] }}</span>
                    </div>
                </ValidationProvider>

                <div class="row">
                    <div class="col-6">
                        <ValidationProvider vid="name_first" :name="__('redeem.name_first')" rules="required" v-slot="{ errors }">
                            <div class="form-group">
                                <label class="text-uppercase" for="name_first">{{ __('redeem.name_first') }}<span class="text-danger">*</span></label>
                                <input
                                    type="text"
                                    id="name_first"
                                    class="form-control"
                                    autocomplete="given-name"
                                    :placeholder="__('redeem.name_first')"
                                    name="name_first"
                                    v-model="form.name_first"
                                    :class="{ 'is-invalid':errors[0] }"
                                    :readonly="!allow_address_change || order_id > 0"
                                >
                                <span class="invalid-feedback">{{ errors[0] }}</span>
                            </div>
                        </ValidationProvider>
                    </div>
                    <div class="col-6">
                        <ValidationProvider vid="name_last" :name="__('redeem.name_last')" rules="required" v-slot="{ errors }">
                            <div class="form-group">
                                <label class="text-uppercase" for="name_last">{{ __('redeem.name_last') }}<span class="text-danger">*</span></label>
                                <input
                                    type="text"
                                    id="name_last"
                                    class="form-control"
                                    autocomplete="family-name"
                                    :placeholder="__('redeem.name_last')"
                                    name="name_last"
                                    v-model="form.name_last"
                                    :class="{ 'is-invalid':errors[0] }"
                                    :readonly="!allow_address_change || order_id > 0"
                                >
                                <span class="invalid-feedback">{{ errors[0] }}</span>
                            </div>
                        </ValidationProvider>
                    </div>
                    <input type="hidden" name="name" v-bind:value="getName"/>
                </div>

                <ValidationProvider v-if="form.delivery_type == 'DPD_F'" id="vcompanyname" vid="company_name" :name="__('redeem.company_name')" rules="required" v-slot="{ errors }">
                    <div class="form-group">
                        <label class="text-uppercase" for="company_name">{{ __('redeem.company') }}<span class="text-danger">*</span></label>
                        <input
                            type="text"
                            id="company_name"
                            class="form-control"
                            autocomplete="organization"
                            :placeholder="__('redeem.company')" name="company_name"
                            v-model="form.company_name"
                            :class="{ 'is-invalid':errors[0] }"
                            :readonly="!allow_address_change"
                        >
                        <span class="invalid-feedback">{{ errors[0] }}</span>
                    </div>
                </ValidationProvider>

                <div class="form-group" v-if="form.delivery_type !== 'online'">
                    <div class="row">
                        <div class="col-auto flex-grow-1">
                            <ValidationProvider vid="street_address_1" :name="__('redeem.street_address')" rules="required" v-slot="{ errors }">
                                <label class="text-uppercase" for="street_address_1">{{ __('redeem.street_address') }}<span class="text-danger">*</span></label>
                                <input
                                    type="text"
                                    id="street_address_1"
                                    class="form-control"
                                    autocomplete="street-address"
                                    :placeholder="__('redeem.street_address')"
                                    name="street_address_1"
                                    v-model="form.street_address_1"
                                    :class="{ 'is-invalid':errors[0] }"
                                    :readonly="!allow_address_change"
                                >
                                <span class="invalid-feedback">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                        <div v-if="form.country_code === 'SE'" class="col-md-3 col-sm-4">
                            <ValidationProvider vid="floor" :name="__('validation.attributes.floor')" rules="lgh" v-slot="{ errors }">
                                <label class="text-uppercase" for="floor">{{ __('redeem.floor') }}</label>
                                <input
                                    type="text"
                                    id="floor"
                                    class="form-control"
                                    autocomplete="off"
                                    :placeholder="__('redeem.floor')"
                                    name="floor"
                                    v-model="form.floor"
                                    :class="{ 'is-invalid':errors[0] }"
                                    :readonly="!allow_address_change"
                                >
                                <span class="invalid-feedback">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                    </div>
                </div>

                <div class="form-group" v-if="form.delivery_type !== 'online'">
                    <div class="row">
                        <div class="col-md-3 col-sm-4">
                            <ValidationProvider vid="postal_code" :name="__('redeem.postal_code')" rules="required" v-slot="{ errors }">
                                <label class="text-uppercase" for="postal_code">{{ __('redeem.postal_code') }}<span class="text-danger">*</span></label>
                                <input
                                    type="text"
                                    id="postal_code"
                                    class="form-control"
                                    autocomplete="postal-code"
                                    :placeholder="__('redeem.postal_code')"
                                    name="postal_code"
                                    v-model="form.postal_code"
                                    :class="{ 'is-invalid':errors[0] }"
                                    :readonly="!allow_address_change"
                                >
                                <span class="invalid-feedback">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                        <div class="col-md-6 col-sm-8">
                            <ValidationProvider vid="city" :name="__('redeem.postal_city')" rules="required" v-slot="{ errors }">
                                <label class="text-uppercase" for="city">{{ __('redeem.postal_city') }}<span class="text-danger">*</span></label>
                                <input
                                    type="text"
                                    id="city"
                                    class="form-control"
                                    autocomplete="address-level2"
                                    :placeholder="__('redeem.postal_city')"
                                    name="city"
                                    v-model="form.city"
                                    :class="{ 'is-invalid':errors[0] }"
                                    :readonly="!allow_address_change"
                                >
                                <span class="invalid-feedback">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                        <div class="col-md-3 col-sm-12">
                            <ValidationProvider vid="country" :name="__('redeem.postal_country')" rules="required" v-slot="{ errors }">
                                <label class="text-uppercase" for="city">{{ __('redeem.postal_country') }}<span class="text-danger">*</span></label>
                                <select
                                    v-if="allow_address_change"
                                    id="country"
                                    class="form-control"
                                    name="country_code"
                                    v-model="form.country_code"
                                    :class="{ 'is-invalid':errors[0] }"
                                >
                                    <option value="">{{ __('redeem.postal_country') }}</option>
                                    <option
                                        v-for="(country, index) in valid_countries"
                                        :key="index"
                                        :value="country.code"
                                        v-text="country.name_local.toUpperCase()"
                                    ></option>
                                </select>
                                <input v-else type="text" name="country_code" class="form-control" :value="form.country_code" readonly>
                                <span class="invalid-feedback">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                    </div>
                </div>

                <ValidationProvider key="vphone" vid="phone" :name="__('redeem.mobile_phone')" :rules="{required: true, is: validPhoneNumber()}" v-slot="{ errors }">
                    <div class="form-group">
                        <label class="text-uppercase" for="phone">{{ __('redeem.mobile_phone') }}<span class="text-danger">*</span></label>
                        <input
                            type="text"
                            id="phone"
                            class="form-control"
                            autocomplete="tel"
                            :placeholder="__('redeem.mobile_phone')"
                            name="phone"
                            v-model="form.phone"
                            :class="{ 'is-invalid':errors[0] }"
                            :readonly="orderExist"
                        >
                        <span class="invalid-feedback">{{ errors[0] }}</span>
                    </div>
                </ValidationProvider>

                <ValidationProvider key="vemail" vid="email" :name="__('redeem.email')" rules="required|email" v-slot="{ errors }">
                    <div class="form-group">
                        <label class="text-uppercase" for="email">{{ __('redeem.email') }}<span class="text-danger">*</span></label>
                        <input
                            type="text"
                            id="email"
                            class="form-control"
                            autocomplete="email"
                            :placeholder="__('redeem.email')"
                            name="email"
                            v-model="form.email"
                            :class="{ 'is-invalid':errors[0] }"
                            :readonly="orderExist"
                        >
                        <span class="invalid-feedback">{{ errors[0] }}</span>
                    </div>
                </ValidationProvider>

                <ValidationProvider v-if="form.delivery_type === 'DPD_F' || form.delivery_type === 'DPD_H'" vid="door_type" :name="__('redeem.door_type')" rules="required" v-slot="{ errors }">
                    <div class="form-group">
                        <label class="text-uppercase" for="door_access_code">{{ __('redeem.door_type') }}</label>
                        <div class="row">
                            <div class="col-12 col-md-6">
                                <div class="form-check">
                                    <input class="form-check-input" type="radio" name="door_type" id="door_type_p"
                                           value="2" v-model="form.door_type" v-bind:class="{ 'is-invalid':errors[0] }"
                                           :readonly="!allow_address_change">
                                    <label class="form-check-label" for="door_type_p">{{ __('redeem.door_phone') }}</label>
                                </div>
                                <div class="form-check">
                                    <input class="form-check-input" type="radio" name="door_type" id="door_type_t"
                                           value="3" v-model="form.door_type" v-bind:class="{ 'is-invalid':errors[0] }"
                                           :readonly="!allow_address_change">
                                    <label class="form-check-label" for="door_type_t">{{ __('redeem.door_tag') }}</label>
                                </div>
                                <div class="form-check">
                                    <input class="form-check-input" type="radio" name="door_type" id="door_type_c"
                                           value="1" v-model="form.door_type" v-bind:class="{ 'is-invalid':errors[0] }"
                                           :readonly="!allow_address_change">
                                    <label class="form-check-label" for="door_type_c">{{ __('redeem.door_code') }}</label>
                                </div>
                            </div>
                            <div class="col-12 col-md-6">
                                <div class="form-check">
                                    <input class="form-check-input" type="radio" name="door_type" id="door_type_o"
                                           value="5" v-model="form.door_type" v-bind:class="{ 'is-invalid':errors[0] }"
                                           :readonly="!allow_address_change">
                                    <label class="form-check-label" for="door_type_o">{{ __('redeem.door_open') }}</label>
                                </div>
                                <div class="form-check">
                                    <input class="form-check-input" type="radio" name="door_type" id="door_type_l"
                                           value="4" v-model="form.door_type" v-bind:class="{ 'is-invalid':errors[0] }"
                                           :readonly="!allow_address_change">
                                    <label class="form-check-label" for="door_type_l">{{ __('redeem.door_locked') }}</label>
                                </div>
                            </div>
                        </div>
                        <span class="invalid-feedback" v-bind:class="{ 'd-block':errors[0] }">{{ errors[0] }}</span>
                    </div>
                </ValidationProvider>

                <ValidationProvider
                    v-if="(form.delivery_type === 'DPD_F' || form.delivery_type === 'DPD_H') && form.door_type === '1'"
                    vid="door_access_code" :name="__('redeem.door_code')" rules="required" v-slot="{ errors }">
                    <div class="row">
                        <div class="col-6">
                            <div class="form-group">
                                <label class="text-uppercase" for="door_access_code">{{ __('redeem.door_code') }}</label>
                                <input type="text" id="door_access_code" class="form-control"
                                       :placeholder="__('redeem.door_code')" name="door_access_code"
                                       v-model="form.door_access_code" v-bind:class="{ 'is-invalid':errors[0] }"
                                       :readonly="!allow_address_change">
                                <span class="invalid-feedback">{{ errors[0] }}</span>
                            </div>
                        </div>
                    </div>
                </ValidationProvider>

                <ValidationProvider v-if="form.delivery_type === 'DPD_F' || form.delivery_type === 'DPD_H'"
                                    vid="transport_instruction" :name="__('redeem.transport_instructions')" rules=""
                                    v-slot="{ errors }">
                    <div class="form-group">
                        <label class="text-uppercase" for="transport_instruction">{{ __('redeem.transport_instructions') }}</label>
                        <textarea rows="4" id="transport_instruction" class="form-control"
                                  :placeholder="__('redeem.transport_instructions')" name="transport_instruction"
                                  v-model="form.transport_instruction" v-bind:class="{ 'is-invalid':errors[0] }"
                                  :readonly="!allow_address_change"></textarea>
                        <span class="invalid-feedback">{{ errors[0] }}</span>
                    </div>
                </ValidationProvider>

                <ValidationProvider vid="want_info_mail" :name="__('redeem.yes_send_more_information')" rules="" v-slot="{ errors }">
                    <div class="form-group">
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" value="1" :true-value="1" :false-value="0" id="want_info_mail"
                                   name="want_info_mail" v-model="form.want_info_mail"
                                   :class="{ 'is-invalid':errors[0] }" :readonly="!allow_address_change">
                            <label class="form-check-label" for="want_info_mail">{{ __('redeem.yes_send_more_information') }}</label>
                            <span class="invalid-feedback">{{ errors[0] }}</span>
                        </div>
                    </div>
                </ValidationProvider>

                <div class="row justify-content-end pt-4">
                    <div class="col-6">
                        <button type="button" class="btn btn-primary btn-block btn-lg" @click="submit">
                            {{ __('redeem.next_step') }} »
                        </button>
                    </div>
                </div>
            </form>
        </ValidationObserver>
    </div>
</template>

<script>
import { localize } from 'vee-validate';
import DeliveryDates from '../utils/DeliveryDates';

export default {
    props: {
        validation_errors: {
            type: [Object, Array],
            default() {
                return {};
            },
        },
        old_form_data: {
            type: [Object, Array],
            default() {
                return {};
            },
        },
        delivery_dates: {
            type: Object,
            default() {
                return {};
            },
        },
        valid_countries: {
            type: Array,
            default() {
                return [];
            },
        },
        allow_delivery_change: {
            type: Boolean,
            default: true,
        },
        order_id: {
            type: Number,
            default: 0,
        },
        allow_address_change: {
            type: Boolean,
            default: true,
        },
        allowed_deliv_types: {
            type: Number,
            default: 0,
        },
        card_type: {
            type: String,
            default: '',
        },
        preselected_deliv_type: {
            type: String,
            default: '',
        },
    },
    data: () => ({
        csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
        form: {
            delivery_date: '',
            delivery_type: '',
            name: '',
            name_first: '',
            name_last: '',
            company_name: '',
            street_address_1: '',
            street_address_2: '',
            floor: '',
            postal_code: '',
            city: '',
            country_code: '',
            phone: '',
            email: '',
            want_info_mail: '',
            door_type: '',
            door_access_code: '',
            transport_instruction: '',
        },
    }),
    mounted() {
        localize(this.__('redeem.current_langcode'));

        if (this.old_form_data) {
            Object.keys(this.form).forEach((key) => {
                if (key in this.old_form_data) {
                    this.form[key] = this.old_form_data[key];
                }
            });
        }

        if (this.form.delivery_date === '') {
            const dates = DeliveryDates.selectDeliveryDates(this, this.delivery_dates, this.old_form_data);
            if (dates && dates[0]) {
                this.form.delivery_date = dates[0].id;
            }
        }

        // eslint-disable-next-line no-bitwise
        if ((this.form.delivery_type & this.allowed_deliv_types) !== this.allowed_deliv_types) {
            this.form.delivery_type = this.preselected_deliv_type;
        }

        const nameArray = this.form.name.split(' ');
        this.form.name_last = nameArray.pop();
        this.form.name_first = nameArray.join(' ');

        if (this.validation_errors) {
            this.$nextTick(() => {
                const self = this;
                self.$refs.mainformvalidation.setErrors(self.validation_errors);
            });
        }
        if (this.valid_countries.length === 1) {
            this.form.country_code = this.valid_countries[0].code;
        }
    },
    methods: {
        async submit() {
            const isValid = await this.$refs.mainformvalidation.validate();
            if (isValid) {
                this.$refs.mainform.submit();
            }
        },
        getNextDayOfTheWeek(dayName, excludeToday = true, refDate = new Date()) {
            const dayOfWeek = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat']
                .indexOf(dayName.slice(0, 3).toLowerCase());
            if (dayOfWeek < 0) return null;
            refDate.setHours(0, 0, 0, 0);
            // eslint-disable-next-line no-mixed-operators
            refDate.setDate(refDate.getDate() + +!!excludeToday + (dayOfWeek + 7 - refDate.getDay() - +!!excludeToday) % 7);

            return new Intl.DateTimeFormat('sv-SE').format(refDate);
        },
        validPhoneNumber() {
            let isError = false;

            const phone = this.form.phone.replace(/[^0-9+]/g, '');

            if (this.form.country_code === 'SE') {
                if (phone.indexOf('07') === 0 && phone.length !== 10) {
                    isError = true;
                } else if (phone.indexOf('+46') === 0 && phone.length !== 12) {
                    isError = true;
                } else {
                    isError = false;
                }
            }

            return isError;
        },
    },
    computed: {
        getName() {
            return this.form.name_first + ' ' + this.form.name_last;
        },
        select_delivery_dates() {
            return DeliveryDates.selectDeliveryDates(this, this.delivery_dates, this.old_form_data);
        },
        orderExist() {
            return this.order_id > 0;
        },
    },
};
</script>
